/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TherapistLinkBranding } from './TherapistLinkBranding';
export type LinkLayoutContext = {
    shell: LinkLayoutContext.shell;
    pageTitle: string;
    therapist?: TherapistLinkBranding;
};
export namespace LinkLayoutContext {
    export enum shell {
        TEBUTO = 'tebuto',
        THERAPIST_BRANDED = 'therapist-branded',
    }
}

